/**
 * Distribution Redux Action Constants
 * 
 * These constants define all action types for distribution monitoring.
 * Used by actions and reducers to maintain consistent action type strings.
 * 
 * @module Distribution
 * @category Constants
 */

// ============================================================================
// DISTRIBUTION LIST
// ============================================================================

/** Fetch distribution list with filters */
export const DISTRIBUTION_LIST_REQUEST = 'DISTRIBUTION_LIST_REQUEST';
export const DISTRIBUTION_LIST_SUCCESS = 'DISTRIBUTION_LIST_SUCCESS';
export const DISTRIBUTION_LIST_FAIL = 'DISTRIBUTION_LIST_FAIL';
export const DISTRIBUTION_LIST_RESET = 'DISTRIBUTION_LIST_RESET';

// ============================================================================
// DISTRIBUTION STATS
// ============================================================================

/** Fetch distribution statistics */
export const DISTRIBUTION_STATS_REQUEST = 'DISTRIBUTION_STATS_REQUEST';
export const DISTRIBUTION_STATS_SUCCESS = 'DISTRIBUTION_STATS_SUCCESS';
export const DISTRIBUTION_STATS_FAIL = 'DISTRIBUTION_STATS_FAIL';

// ============================================================================
// FLAGGED DISTRIBUTIONS
// ============================================================================

/** Fetch flagged distributions for review */
export const FLAGGED_DISTRIBUTIONS_REQUEST = 'FLAGGED_DISTRIBUTIONS_REQUEST';
export const FLAGGED_DISTRIBUTIONS_SUCCESS = 'FLAGGED_DISTRIBUTIONS_SUCCESS';
export const FLAGGED_DISTRIBUTIONS_FAIL = 'FLAGGED_DISTRIBUTIONS_FAIL';

// ============================================================================
// DISTRIBUTION REVIEW
// ============================================================================

/** Review a flagged distribution */
export const DISTRIBUTION_REVIEW_REQUEST = 'DISTRIBUTION_REVIEW_REQUEST';
export const DISTRIBUTION_REVIEW_SUCCESS = 'DISTRIBUTION_REVIEW_SUCCESS';
export const DISTRIBUTION_REVIEW_FAIL = 'DISTRIBUTION_REVIEW_FAIL';
export const DISTRIBUTION_REVIEW_RESET = 'DISTRIBUTION_REVIEW_RESET';

/** Bulk review multiple distributions */
export const DISTRIBUTION_BULK_REVIEW_REQUEST = 'DISTRIBUTION_BULK_REVIEW_REQUEST';
export const DISTRIBUTION_BULK_REVIEW_SUCCESS = 'DISTRIBUTION_BULK_REVIEW_SUCCESS';
export const DISTRIBUTION_BULK_REVIEW_FAIL = 'DISTRIBUTION_BULK_REVIEW_FAIL';
export const DISTRIBUTION_BULK_REVIEW_RESET = 'DISTRIBUTION_BULK_REVIEW_RESET';

// ============================================================================
// AGENT LEADERBOARD
// ============================================================================

/** Fetch agent leaderboard */
export const AGENT_LEADERBOARD_REQUEST = 'AGENT_LEADERBOARD_REQUEST';
export const AGENT_LEADERBOARD_SUCCESS = 'AGENT_LEADERBOARD_SUCCESS';
export const AGENT_LEADERBOARD_FAIL = 'AGENT_LEADERBOARD_FAIL';

// ============================================================================
// DISTRIBUTION REPORTS
// ============================================================================

/** Fetch advanced distribution reporting analytics */
export const DISTRIBUTION_REPORTS_REQUEST = 'DISTRIBUTION_REPORTS_REQUEST';
export const DISTRIBUTION_REPORTS_SUCCESS = 'DISTRIBUTION_REPORTS_SUCCESS';
export const DISTRIBUTION_REPORTS_FAIL = 'DISTRIBUTION_REPORTS_FAIL';

/** Export distribution report data */
export const DISTRIBUTION_REPORT_EXPORT_REQUEST = 'DISTRIBUTION_REPORT_EXPORT_REQUEST';
export const DISTRIBUTION_REPORT_EXPORT_SUCCESS = 'DISTRIBUTION_REPORT_EXPORT_SUCCESS';
export const DISTRIBUTION_REPORT_EXPORT_FAIL = 'DISTRIBUTION_REPORT_EXPORT_FAIL';
export const DISTRIBUTION_REPORT_EXPORT_RESET = 'DISTRIBUTION_REPORT_EXPORT_RESET';

/** Fetch distribution report records table */
export const DISTRIBUTION_REPORT_RECORDS_REQUEST = 'DISTRIBUTION_REPORT_RECORDS_REQUEST';
export const DISTRIBUTION_REPORT_RECORDS_SUCCESS = 'DISTRIBUTION_REPORT_RECORDS_SUCCESS';
export const DISTRIBUTION_REPORT_RECORDS_FAIL = 'DISTRIBUTION_REPORT_RECORDS_FAIL';

/** Export distribution report records table */
export const DISTRIBUTION_REPORT_RECORDS_EXPORT_REQUEST = 'DISTRIBUTION_REPORT_RECORDS_EXPORT_REQUEST';
export const DISTRIBUTION_REPORT_RECORDS_EXPORT_SUCCESS = 'DISTRIBUTION_REPORT_RECORDS_EXPORT_SUCCESS';
export const DISTRIBUTION_REPORT_RECORDS_EXPORT_FAIL = 'DISTRIBUTION_REPORT_RECORDS_EXPORT_FAIL';
export const DISTRIBUTION_REPORT_RECORDS_EXPORT_RESET = 'DISTRIBUTION_REPORT_RECORDS_EXPORT_RESET';

/** Fetch final reminder candidate list */
export const FINAL_REMINDER_CANDIDATES_REQUEST = 'FINAL_REMINDER_CANDIDATES_REQUEST';
export const FINAL_REMINDER_CANDIDATES_SUCCESS = 'FINAL_REMINDER_CANDIDATES_SUCCESS';
export const FINAL_REMINDER_CANDIDATES_FAIL = 'FINAL_REMINDER_CANDIDATES_FAIL';

/** Export final reminder notices */
export const FINAL_REMINDER_EXPORT_REQUEST = 'FINAL_REMINDER_EXPORT_REQUEST';
export const FINAL_REMINDER_EXPORT_SUCCESS = 'FINAL_REMINDER_EXPORT_SUCCESS';
export const FINAL_REMINDER_EXPORT_FAIL = 'FINAL_REMINDER_EXPORT_FAIL';
export const FINAL_REMINDER_EXPORT_RESET = 'FINAL_REMINDER_EXPORT_RESET';
